export const language: any ={
    cancel: "Annuler",
    ok: "Ok",
}